import React from "react";
import Decimal from "decimal.js-light";
import { styled } from "@mui/material/styles";
import { compose } from "redux";

import { withTaxCalculation } from "../components/Taxation/withTaxCalculation";

const ColoredSpan = styled("span")(({ theme, amount }) => {
  const value = new Decimal(amount);
  if (value.isZero()) {
    return {
      color: "#4caf50", // green
    };
  } else if (value.isPositive()) {
    return {
      color: "red",
    };
  } else {
    return {
      color: "orange",
    };
  }
});

export const withTaxWillHide = (WrapComp) => (props) => {
  const { record } = props;
  if (record && record.tax) {
    return null;
  } else {
    return <WrapComp {...props} record={record} />;
  }
};

export const withTaxWillShow = (WrapComp) => (props) => {
  const { record } = props;
  if (record && record.tax) {
    return <WrapComp {...props} record={record} />;
  } else {
    return null;
  }
};

const withAmount = (WrapComp) => (props) => {
  const { calculation, source } = props;
  const amountDecimal = new Decimal(calculation[source]);
  return <WrapComp {...props} amount={amountDecimal.toFixed(2)} />;
};

const withColor = (WrapComp) => (props) => {
  return <WrapComp {...props} />;
};

const SpanField = (props) => {
  const { amount } = props;
  return <ColoredSpan amount={amount}>{amount}</ColoredSpan>;
};

export const AmountWithTaxColorField = compose(
  withTaxWillShow,
  withTaxCalculation,
  withAmount,
  withColor
)(SpanField);

export const AmountWithTaxField = compose(
  withTaxWillShow,
  withTaxCalculation,
  withAmount
)((props) => <span>{props.amount}</span>);

export default AmountWithTaxField;
